import React from 'react';
import SignupForm from './SignupForm';

// Rendered inside the "Join Our Mailing List" section on the home page, which
// already supplies the section element, background and heading — so this is
// just the card and the form. (It previously nested a second <section> with
// its own padding and a competing <h2>.)
const MailingList = () => (
  <div className="max-w-2xl mx-auto">
    <p className="text-xl text-gray-600 mb-10">
      Stay updated with our latest wines, events, and exclusive offers!
    </p>

    <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 text-left">
      <SignupForm />
      <p className="text-sm text-gray-500 text-center mt-6">
        We respect your privacy. Unsubscribe at any time.
      </p>
    </div>
  </div>
);

export default MailingList;
